import React, {FC} from 'react'
import { useDispatch, useSelector, connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useDidUpdate, useTimeout } from 'react-nb-hooks'
import { Segment, Grid } from 'semantic-ui-react'
import moment from 'moment'
import size from 'lodash/size'
import { withLivedata, withSystemConfig, colors, withConstantPermissions } from 'shared'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { dateTime as dateTimeFormatter } from 'loankeeper-common/helpers/formatters'
//@ts-ignore
import { SegmentGroup, FlexTableChild, TableContainer, GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { actions as DetailsContainerActions, constants as DCConstants } from '../../../DetailsContainer'
import { REDUCER_NAME } from './constants'
import { CLIENT_ADD_NAVIGATION_MODAL } from '../../../ClientAdd'
import { translateCmd, translateBase, icon } from '../../helpers'
import { formName } from '../../constants'
import ClientInfo from './ClientInfo'
import { CivilRegistryRawProps, CivilRegistryRawState, CivilRegistryProps } from '../../types'
import { GridApi } from 'ag-grid'

type anyType = {
  api?: any
}

const config = {
  gridIdentity: { formName, objectName: 'dbgrd_cra' },

  syncGridState: true,
  selectLastRow: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableTranslate: true,
  enableRowSelection: true,

  getRowStyle: ({
    node: {
      data: { ResultStatus_Code },
    },
  }) => {
    if (ResultStatus_Code !== 14) {
      return { backgroundColor: colors.grey }
    }
    return {}
  },

  columnConfigs: {
    RDate: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    TypeID: { cellStyle: { textAlign: 'right' } },
    ResponseDate: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    Response_Id: { cellStyle: { textAlign: 'right' } },
    Response_TimeStamp: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    ResultStatus_Code: { cellStyle: { textAlign: 'right' } },
    Document_ID: { cellStyle: { textAlign: 'right' } },
    Document_StatusId: { cellStyle: { textAlign: 'right' } },
    Person_BirthDate: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
    Person_PersonStatusId: { cellStyle: { textAlign: 'right' } },
    Person_ID: { cellStyle: { textAlign: 'right' } },
    Registration_ActiveAddressAddressID: { cellStyle: { textAlign: 'right' } },
    Registration_OA_ID: { cellStyle: { textAlign: 'right' } },
    Photo_Id: { cellStyle: { textAlign: 'right' } },
  },
  getContextMenuItems: () => ['excelExport'],
}

//@ts-ignore
@withConstantPermissions(['SDA_CRA_REQUEST_DATA as CRPermission'])
//@ts-ignore
@withLivedata('OpenDayStatus.Cur_Date')
//@ts-ignore
@withSystemConfig('SDACRAConfig')
//@ts-ignore
@connect(undefined, (dispatch, { ID, hash }) => ({
  openClientAddSDA: ({ ClientID, ClientHash, FullName, PersonalNo, IDDocNo, BirthYear }, callback) =>
    dispatch(
      LKModalActions.open({
        name: `${CLIENT_ADD_NAVIGATION_MODAL}-AddClientForm`,
        clientType: 2,
        ClientID,
        ClientHash,
        PersonalNo,
        IDDocNo,
        BirthYear,
        FullName,
        callback,
      }),
    ),

  fetchCra: () => {
    //@ts-ignore
    dispatch([
      DetailsContainerActions.fetchPage({
        type: 'Client',
        ID,
        hash,
        page: 'base',
      }),
      DetailsContainerActions.fetchPage({
        type: 'Client',
        ID,
        hash,
        page: 'cra',
      }),
    ])
  },
}))
class CivilRegistryRaw extends React.PureComponent<CivilRegistryRawProps, CivilRegistryRawState> {
  static defaultProps = {
    data: [],
  }

  state = {
    selectedData: {},
    gridLaoad: false,
  }
  api: GridApi

  componentDidMount() {
    setTimeout(() => {
      if (this.state.gridLaoad && this.api) {
        this.getLastRow()
      }
    }, 1000)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data && nextProps.data.cra && nextProps.data.cra.length > 0) {
      return { gridLaoad: true }
    }
    return null
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data.cra.length !== this.props.data.cra.length) {
      setTimeout(() => {
        if (this.api) {
          this.getLastRow()
        }
      }, 1000)
    }
  }

  showClientData = ({ node: { data, selected } }) => {
    if (selected) {
      this.setState({ selectedData: data })
    }
  }

  openClientAddSDA = () => {
    const { base } = this.props.data
    this.props.openClientAddSDA(
      {
        ClientID: this.props.ID,
        ClientHash: this.props.hash,
        FullName: base.FullName,
        PersonalNo: base.CardNumber,
        IDDocNo: base.IDSerial,
        BirthYear: moment(base.DOB).format('YYYY'),
      },
      this.handleSDACallback,
    )
  }

  handleSDACallback = () => {
    this.props.fetchCra()
  }

  getLastRow = () => {
    this.api.forEachNode((node) => {
      node.setSelected(node.rowIndex === this.props.data.cra.length - 1)
    })
  }

  onGridReady = (params) => {
    this.api = params.api
  }

  render() {
    const { selectedData } = this.state

    const {
      data: { cra, base },
      ID,
      CRPermission,
      firstSelect,
    } = this.props
    const LKGridInstanceName = `${DCConstants.DetailsGridPrefixes.client}-${ID}-CivilRegistry`
    return (
      <SegmentGroup>
        <Segment.Group>
          <FlexTableChild>
            <div style={{ width: '100%', height: '100%', display: 'flex' }}>
              <TableContainer style={{ flex: 2 }}>
                <LKGrid
                  rowData={firstSelect ? cra : this.props.cra}
                  onRowSelected={this.showClientData}
                  {...config}
                  instanceName={LKGridInstanceName}
                  onGridReady={this.onGridReady}
                />
              </TableContainer>
              {/*@ts-ignore*/}
              <div style={{ flex: 3 }}>{!!size(selectedData) && <ClientInfo data={selectedData} base={base} />}</div>
            </div>
          </FlexTableChild>
          {CRPermission ? (
            <Segment>
              <GridContainer>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={5}>
                      <LKButton alias="info" onClick={this.openClientAddSDA}>
                        {translateCmd('sda')}
                      </LKButton>
                    </Grid.Column>

                    <Grid.Column width={1}>
                      <LKGridExportButton alias="export" size="tiny" instanceName={LKGridInstanceName} />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            </Segment>
          ) : (
            ''
          )}
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

const CivilRegistry: FC<CivilRegistryProps> = React.memo((props) => {
  const dispatch = useDispatch()

  // workaround for Rezi's mess
  const { cra, firstSelect } : {cra: any, firstSelect: boolean} = useSelector(
    (state) => state[REDUCER_NAME][props.ID] || { cra: undefined, firstSelect: true },
  )

  const location = useLocation()
  const [isVisible, setVisible] = React.useState(true)

  useDidUpdate(() => {
    setVisible(false)

    dispatch(
      DetailsContainerActions.fetchPage({
        type: 'Client',
        ID: props.ID,
        hash: props.hash,
        page: 'cra',
      }),
    )
  }, [location.pathname])

  useTimeout(
    () => {
      setVisible(true)
    },
    isVisible ? null : 500,
  )

  if (!isVisible) {
    return null
  }
  //@ts-ignore
  return <CivilRegistryRaw {...props} cra={cra} firstSelect={firstSelect} />
})

//@ts-ignore
CivilRegistry.config = {
  title: () => translateBase('tb_sda'),
  name: 'civilregistry',
  component: CivilRegistry,
  api: ['cra', 'base'],
  icon: icon('tb_sda'),
}

export default CivilRegistry
